const PatientFilterNames = {
  MY_PATIENTS: 'caseFilter.myPatients',
  ALL_PATIENTS: 'caseFilter.allPatients',
  SELECTED_PATIENTS: 'caseFilter.selectedPatients',
  NO_PATIENTS: 'caseFilter.noPatients',
}

export { PatientFilterNames }
